export type { RawLoaderWorker, RawInfo } from "./raw-loader.worker"
import { PeerConnection } from "@/utils/peer"
import RawLoaderWorkerUrl from "./raw-loader.worker.ts?worker&url"
import type { RawLoaderWorker } from "./raw-loader.worker"

export const RawLoaderConnection = new PeerConnection<RawLoaderWorker>(RawLoaderWorkerUrl, {
	label: "RAW Loader",
	dependencies: {},
})

export const AuxiliaryAIRawLoaderConnection = new PeerConnection<RawLoaderWorker>(
	RawLoaderWorkerUrl,
	{
		label: "AI Auxiliary RAW Loader",
		dependencies: {},
	},
)
